<template>
  <div v-if="isGraphTypeLinechart" class="sf-pad-h-3 sf-pad-v-2">
    <table class="sf-table sf-table-middle" cellspacing="8">
      <tbody>
        <tr>
          <td class="sf-nowrap sf-pad-r-1" width="1">
            <label for="minimum">{{
              I18n.t('js.report_graph.edit.minimum')
            }}</label>
          </td>

          <td>
            <input
              id="minimum_axis_value_editor"
              v-model="minimum"
              class="sf-form-input sf-full"
              :class="{ 'sf-disabled': readOnly }"
              type="number"
              name="minimum"
            />
          </td>
        </tr>

        <tr>
          <td class="sf-nowrap sf-pad-r-1" width="1">
            <label for="maximum">{{
              I18n.t('js.report_graph.edit.maximum')
            }}</label>
          </td>

          <td>
            <input
              id="maximum_axis_value_editor"
              v-model="maximum"
              class="sf-form-input sf-full"
              :class="{ 'sf-disabled': readOnly }"
              type="number"
              name="maximum"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState(['graph', 'readOnly']),
    ...mapGetters(['isGraphTypeLinechart']),
    minimum: {
      get() {
        return this.graph.minimum
      },
      set(newMinimum) {
        this.setMinimumValues({ minimum: newMinimum })
      },
    },
    maximum: {
      get() {
        return this.graph.maximum
      },
      set(newMaximum) {
        this.setMaximumValues({ maximum: newMaximum })
      },
    },
  },

  methods: {
    ...mapActions(['setMaximumValues', 'setMinimumValues']),
  },
}
</script>
